

import {computed, ref} from 'vue'
import {useToast} from "primevue/usetoast";
import moment from 'moment';
import {RegisterServiceByWeb} from "@/models/registerServiceByWeb";
import zaloRepository from "@/services/ZaloRepository";
import router from "@/router";

export default {
  setup(props){
    const toast = useToast();
    const register = ref({} as RegisterServiceByWeb);
    register.value.hour = 0;
    const follow = ref(false);
    const gioDatLich = ref([
      {value: 7},
      {value: 8},
      {value: 9},
      {value: 10},
      {value: 11},
      {value: 12},
      {value: 13},
      {value: 14},
      {value: 15},
      {value: 16},
      {value: 17},
    ]);

    const toTimestamp = (strDate) => {
      const dt = Date.parse(strDate);
      return dt / 1000;
    }

    const formatDateTime = (date) => {
      return moment(String(date)).format('YYYY-MM-DD');
    };
    const minDate = ref(new Date());
    const addRegister = () => {
      follow.value = false;
      register.value.serviceName = "Đặt lịch khám";
      register.value.serviceCode = "#datlichkham";
            zaloRepository.registerServiceByWeb(register.value)
                .then((response) => {
                  toast.add({
                    severity: 'success',
                    summary: 'Thành công',
                    detail: 'Đăng ký khám bệnh thành công',
                    life: 2000
                  });
                  const temp = ref({} as RegisterServiceByWeb);
                  register.value = temp.value;
                  register.value.hour = 0;
                })
                .catch(err => {
                  follow.value = true;
                  toast.add({
                    severity: 'error',
                    summary: 'Lỗi',
                    detail: err.response.data,
                    life: 2000
                  });
                });
  }
    const valid = ()=> { return register.value.customerName && register.value.year && register.value.phoneNumber && register.value.timeBooking};
    const openLink = () => {
      window.open("https://zalo.me/1927160331485645584", '_blank');
    };

    return {
      register,
      minDate,
      addRegister,
      valid,
      follow,
      openLink,
      gioDatLich
      // nonAccentVietnamese
    }
  }

}
